<div class='main-content'>
    <div class='container'>
        <div class='card'>
            <div class="card-header">
                <div class='row justify-content-center'>
                    <h1 class="card-title">Alta Riesgo</h1>
                </div>
                <div class="col-md-4" *ngIf="esEditar">
                    <button mat-button class="btn btn-info" (click)="regresar()">Regresar</button>
                </div>
                <mat-divider></mat-divider>

            </div>

            <div class="card-body ">
                <mat-horizontal-stepper linear #stepper>
                    <mat-step [stepControl]='primerGrupo'>
                        <ng-template matStepLabel>Descripción Riesgo</ng-template>
                        <app-descripcion-riesgo [riesgo]='riesgo' [primerGrupo]='primerGrupo'>
                        </app-descripcion-riesgo>
                    </mat-step>
                    <mat-step [stepControl]='evaluacionRiesgoGroup'>
                        <ng-template matStepLabel>Evaluación Riesgo</ng-template>
                        <app-evaluacion-riesgo [riesgo]='riesgo' [evaluacionRiesgoGroup]='evaluacionRiesgoGroup'>
                        </app-evaluacion-riesgo>
                    </mat-step>
                    <mat-step [stepControl]='controlesRiesgoGroup'>
                        <ng-template matStepLabel>Controles Riesgo</ng-template>
                        <app-controles-riesgo [riesgo]='riesgo' [controlesRiesgoGroup]='controlesRiesgoGroup'
                        (agregarRiesgo)='guardar()'>
                        </app-controles-riesgo>
                    </mat-step>
                </mat-horizontal-stepper>
            </div>

        </div>
    </div>
</div>